"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Composition = _interopRequireDefault(require("composer-lib/data/model/Composition"));

var _lockHelpers = require("composer-lib/lib/helpers/lockHelpers");

var _reactRedux = require("react-redux");

var _Lock = _interopRequireDefault(require("composer-lib/data/model/Lock"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _constants = require("composer-lib/lib/constants");

var _Revisions = _interopRequireDefault(require("composer-lib/data/model/Revisions"));

var _SaveState = _interopRequireDefault(require("composer-lib/data/model/SaveState"));

var _uiSettings = require("composer-lib/redux/actions/uiSettings");

var _RevisionsButton = _interopRequireDefault(require("composer-lib/components/composer/RevisionsButton"));

var mapStateToProps = function mapStateToProps(state) {
  return {
    auth: state.auth,
    composition: state.composition,
    lock: state.lock,
    revisions: state.revisions,
    saveState: state.save
  };
};

var mapDispatchToProps = {
  showRevisions: _uiSettings.showRevisions
};
var RevisionsButtonContainer = (0, _createReactClass.default)({
  displayName: "RevisionsButtonContainer",
  propTypes: {
    auth: _propTypes.default.object.isRequired,
    composition: _propTypes.default.instanceOf(_Composition.default).isRequired,
    lock: _propTypes.default.instanceOf(_Lock.default).isRequired,
    onClick: _propTypes.default.func,
    revisions: _propTypes.default.instanceOf(_Revisions.default).isRequired,
    saveState: _propTypes.default.instanceOf(_SaveState.default).isRequired,
    showRevisions: _propTypes.default.func.isRequired
  },
  render: function render() {
    var _this$props = this.props,
        auth = _this$props.auth,
        composition = _this$props.composition,
        lock = _this$props.lock,
        onClick = _this$props.onClick,
        revisions = _this$props.revisions,
        saveState = _this$props.saveState;

    if (composition.isReadOnly()) {
      return null;
    }

    var disabled = (0, _lockHelpers.compositionLocked)(lock, auth, saveState) || revisions.objects.size < 1 && revisions.fetchStatus !== _constants.RequestStatus.FAILED;

    return _react.default.createElement(_RevisionsButton.default, {
      disabled: disabled,
      onClick: onClick,
      showRevisions: this.props.showRevisions
    });
  }
});

var _default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(RevisionsButtonContainer);

exports.default = _default;
module.exports = exports.default;